import { render, staticRenderFns } from "./LocaleSwitch.vue?vue&type=template&id=0d7e3205&"
import script from "./LocaleSwitch.vue?vue&type=script&lang=js&"
export * from "./LocaleSwitch.vue?vue&type=script&lang=js&"
import style0 from "./LocaleSwitch.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports